var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notifications-badge"},[_c('common-icon',{attrs:{"name":"notifications","size":"large"}}),_c('common-badge',{attrs:{"content":_vm.count}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }